import type {
  CandidateEvaluationState,
  CandidateEvaluationAPI,
  Validations,
  ValidationsWithoutResume,
} from 'src/types/candidate-evaluation';
import {
  normalizeNodeSchedule,
  parseNodeSchedule,
} from 'src/utils/node-schedule';
import {
  normalizeUtmConfig,
  getDefaultUtmConfigState,
} from 'src/utils/utm-config';


type NormalizeCandidateEvaluationProps = {
  workflowId: string;
} & CandidateEvaluationState;

export const normalizeCandidateEvaluation = (
  candidateEvaluationNormalizePayload: NormalizeCandidateEvaluationProps,
): CandidateEvaluationAPI => {
  const {
    transcript,
    transcript_source,
    resume,
    job_id,
    job_title,
    job_description,
    recipient_entity_id,
    conversation_id,
  } = candidateEvaluationNormalizePayload;

  const nodeSchedule = normalizeNodeSchedule(
    candidateEvaluationNormalizePayload,
  );
  const utmConfig = normalizeUtmConfig(getDefaultUtmConfigState());
  const payload = {
    job_id,
    job_title,
    job_description,
    resume,
    transcript,
    transcript_source,
    recipient_entity_id,
    conversation_id,
  } as const;

  const finalPayload = Object.keys(payload).reduce<Record<string, any>>(
    (acc, key) => {
      // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly job_id: string | null | undefined; readonly job_title: string | null | undefined; readonly job_description: string | null | undefined; readonly resume: string | null | undefined; readonly transcript: string | ... 1 more ... | undefined; readonly transcript_source: string | ... 1 more ... | undefined; read...'.
      if (payload[key]) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly job_id: string | null | undefined; readonly job_title: string | null | undefined; readonly job_description: string | null | undefined; readonly resume: string | null | undefined; readonly transcript: string | ... 1 more ... | undefined; readonly transcript_source: string | ... 1 more ... | undefined; read...'.
        acc[key] = payload[key];
      }
      return acc;
    },
    {},
  );

  return {
    task: {
      params: {
        ...finalPayload,
      },
    },
    ...nodeSchedule,
    ...utmConfig,
  };
};

export const parseCandidateEvaluation = (
  data: CandidateEvaluationAPI,
): CandidateEvaluationState => {
  const candidateEvaluationParams = data.task.params;
  const {
    job_id,
    job_title,
    job_description,
    resume,
    transcript,
    transcript_source,
    recipient_entity_id,
    conversation_id,
    // previous_node_info,
  } = candidateEvaluationParams;
  const nodeSchedule = parseNodeSchedule(data);

  return {
    job_id,
    job_title,
    job_description,
    resume,
    transcript,
    transcript_source,
    recipient_entity_id,
    conversation_id,
    ...nodeSchedule,
  };
};

export const getErrors = (validations: Validations): Array<string> => {
  const errors: Array<string> = [];
  const {
    jobIdEmpty,
    jobTitleEmpty,
    jobDescEmpty,
    additionalInputEmpty,
    previousNodeInputInvalid,
  } = validations || {};

  if (jobIdEmpty || jobTitleEmpty || jobDescEmpty) {
    errors.push('Please fill the required fields.');
  }
  if (additionalInputEmpty) {
    errors.push('Add at least one additional input (Previous Node / Resume).');
  }
  if (previousNodeInputInvalid) {
    errors.push('Only voiceflow nodes are allowed.');
  }
  return errors;
};

export const getErrorsWithoutResume = (
  validations: ValidationsWithoutResume,
): Array<string> => {
  const errors: Array<string> = [];
  const {
    jobIdEmpty,
    jobTitleEmpty,
    jobDescEmpty,
    previousNodeInputEmpty,
    previousNodeInputInvalid,
  } = validations || {};

  if (jobIdEmpty || jobTitleEmpty || jobDescEmpty) {
    errors.push('Please fill the required fields.');
  }
  if (previousNodeInputEmpty) {
    errors.push('Please fill previous node input.');
  }
  if (previousNodeInputInvalid) {
    errors.push('Only voiceflow nodes are allowed.');
  }
  return errors;
};
